<template>
  <div>
    <div v-if="!resumed">
      <div class="row" v-if="!loading">
        <CampaignStepTemplate
          v-for="i in [1,2,3]"
          class="mt-4"
          :defaultTokens="true"
          :onlyresult="true"
          :simplify="false"
          :emailTo="email_to"
          :availableTokens="availableTokensSelect"
          :availableTokensSelect="availableTokensSelect"
          :campaignStepTemplatePartId="1"
          :campaignStepTemplateTypeId="1"
          :step="i"
          :key="i"
          :currentUser="currentUser"
          :lang="$store.state.onboarding.language_id"
          :statusTemplate="2"
          :templateId ="templateId"
          :cantPerPage = "1"
          :isPreviewEmail="true"
          :tag_id="tag_id"
        />
      </div>
    </div>

    <div v-if="resumed" >
      
      <div class=" ml-1  pb-4 border-left border-1 border-secondary"  v-for="i in [1,2,3,4,5,6]" :key="i">
        <div class="row">
          <div class="cursor-pointer" @click="openRow(i)">

            <div class="row ml-1">
                <div class="d-inline float-left mr-2">        
                    <span class="cursor-pointer" @click="openRow(i)">
                     <span 
                     class="bg-primary text-white px-2 rounded-circle">{{i}}</span> 
                     <span  class="ml-2">Subject: {{ subject }} : {{ currentUser.name }}</span>
                    </span>
                  </div> 
                  <div class="d-inline">
                    <CampaignStepTemplate
                      :key="keytemplate+100"
                      :availableTokens="availableTokensSelect"
                      :availableTokensSelect="availableTokensSelect"
                      :campaignStepTemplateTypeId="1"
                      :campaignStepTemplatePartId="2"
                      :step="1"
                      :onlyresult="true"
                      :simplify="true"
                      :lang="$store.state.onboarding.language_id"
                      :currentUser="currentUser"
                      :cantPerPage = "1"
                      :isPreviewEmail="true"
                      :tag_id="tag_id"
                    />
                  </div>
              </div>

          </div>
        </div>
        <div class="ml-1 row" v-if="open == i">
          <div class="col-md-12">
            <div class="contentMail">
              <CampaignStepTemplate
                v-if="!loading"
                class="mt-4"
                :defaultTokens="true"
                :key="keytemplate"
                :onlyresult="true"
                :simplify="true"
                :availableTokens="availableTokensSelect"
                :availableTokensSelect="availableTokensSelect"
                :campaignStepTemplatePartId="1"
                :campaignStepTemplateTypeId="1"
                :step="i"
                :currentUser="currentUser"
                :lang="$store.state.onboarding.language_id"
                :statusTemplate="2"
                :cantPerPage = "1"
                :isPreviewEmail="true"
                :tag_id="tag_id"
              />
            </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { campaignsService } from '@/_services';
import CampaignStepTemplate from "@/components/Account/CampaignStepTemplate.vue";
export default {
  components: { CampaignStepTemplate },
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      onBoarding: (state) => state.onboarding,
      completeLoading: (state) => state.optionsList.completeLoading,
      availableTokens: (state) => state.optionsList.all["available_tokens"],
    }),
  },
  data() {
    return {
      open:1,
      keytemplate: 322333,
      availableTokensSelect: [],
      loading:true,
    };
  },
  props: {
    email_to: String,
    body: String,
    important: Array,
    user: Object,
    resumed: Boolean,
    subject: String,
    templateId:Number,
    tag_id: {
      type: [Number,String],
      default: undefined,
    },
  },

  created() {
    if(this.availableTokens !== undefined){
      this.availableTokensSelect = this.availableTokens["data"];
      this.loading=false
    }else{
      campaignsService
        .getAvailableTokens().then(
          (response) => {
            this.availableTokensSelect = response
            this.loading=false
          });
    }
  },

  methods: {
    openRow(i){
      this.open=i
    }
  },
};
</script>
